import { ControlTypes } from '@customer-apps/shared/enums';
import { QuestionGroupBase } from './question-group-base.model';
import { RadioQuestion } from './radio.model';
import { TextboxQuestion } from './textbox.model';

export class CustomAnswerRadio extends QuestionGroupBase<[RadioQuestion, TextboxQuestion]> {
    override controlType = ControlTypes.CustomAnswerRadio;
}
